<script setup>
import { useRoute, useRouter } from "vue-router";
import authStore from "../../store/auth";
import { post } from "../../helpers/api";
import SidenavItem from "./SidenavItem.vue";

const router = useRouter();

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};

const handleLogout = () => {
  post("/company-logout")
    .then((response) => {
      if (response.data.status == "success") {
        authStore.remove();
        router.push("/signin");
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
</script>
<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="/dashboard"
          :class="getRoute() === 'dashboard' ? 'active' : ''"
          navText="Dashboard"
        >
          <template v-slot:icon>
            <i class="fas fa-tv text-primary text-sm opacity-10 mb-1"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/invoices"
          :class="getRoute() === 'invoices' ? 'active' : ''"
          navText="Invoices"
        >
          <template v-slot:icon>
            <i class="fas fa-file-invoice text-dark text-sm opacity-10 mb-2"></i>
          </template>
        </sidenav-item>
      </li>

      <!-- <li class="nav-item">
        <sidenav-item
          to="/reports"
          :class="getRoute() === 'reports' ? 'active' : ''"
          navText="Reports"
        >
          <template v-slot:icon>
            <i class="fas fa-chart-line text-success text-sm opacity-10 mb-2"></i>
          </template>
        </sidenav-item>
      </li> -->

      <!-- <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2"
        >
          ACCOUNT
        </h6>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          navText="Profile"
        >
          <template v-slot:icon>
            <i class="fas fa-user text-dark text-sm opacity-10 mb-2"></i>
          </template>
        </sidenav-item>
      </li> -->

      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2"
        >
          SYSTEM
        </h6>
      </li>

      <li class="nav-item">
        <a href="#" class="nav-link" @click.prevent="handleLogout">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <i class="fa fa-sign-out-alt text-danger text-sm opacity-10 mb-1"></i>
          </div>
          <span class="nav-link-text ms-1">Sign Out</span>
        </a>
      </li>
    </ul>
  </div>
</template>
